import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-triangle-right-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [attr.fill]="fill()"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M5.85 4.577L4.208 2.935L1.533 0.26C0.967 -0.298 0 0.102 0 0.902V6.093V10.768C0 11.568 0.967 11.968 1.533 11.402L5.85 7.085C6.542 6.402 6.542 5.268 5.85 4.577Z"
        fill="currentColor" />
    </svg>
  `,
})
export class TriangleRightIconComponent extends BaseIconComponent {
  override width = input<string>('0.4375rem');
  override height = input<string>('0.75rem');
  override viewBox = input<string>('0 0 7 12');
  override fill = input<string>('currentColor');
}
